// extracted by mini-css-extract-plugin
export default {"root":"BkNZ8","desktop":"Jp_DK","skeleton":"mMLVk","date":"BfWBs","messagesGroup":"gnjP2","rightMessage":"U6E6c"};